// removed by extract-text-webpack-plugin
module.exports = {"header":"c-OrderHeader__header","content":"c-OrderHeader__content","sticky":"c-OrderHeader__sticky"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/OrderHeader/OrderHeader.scss
// module id = 944
// module chunks = 0